import { Modal, Table } from 'antd';
import { ColumnsType, TableProps } from 'antd/lib/table';
import React, { ReactElement } from 'react';
import IApplicationEmailRecipient from '~Api/ApplicationEmail/IApplicationEmailRecipient';
import RecipientTypeEnum from '~Api/ApplicationEmail/RecipientTypeEnum';
import './emails.less';
import recipientTypeLabels from './recipientTypeLabels';

export default function RecipientsModal(props: {
    isOpen: boolean;
    onCancel: () => void;
    recipients: IApplicationEmailRecipient[];
    recipientType: RecipientTypeEnum;
}): ReactElement {
    const { isOpen, onCancel, recipients, recipientType } = props;

    const columns: ColumnsType<IApplicationEmailRecipient> = [
        {
            dataIndex: 'name',
            key: 'name',
            title: 'Name',
        },
        {
            dataIndex: 'email',
            key: 'email',
            title: 'Email',
        },
    ];
    const scroll: TableProps<IApplicationEmailRecipient>['scroll'] = { y: 400 };

    return (
        <Modal
            className='application-emails-recipients-modal'
            footer={false}
            onCancel={onCancel}
            open={isOpen}
            title={recipientTypeLabels[recipientType]}
            width={760}
        >
            <Table
                columns={columns}
                dataSource={recipients}
                pagination={false}
                rowKey='email'
                scroll={scroll}
                size='small'
            />
        </Modal>
    );
}
